<section class="profile-progress-bar test-bar">
  <section *ngIf="showTestDescription" class="testActions Flexbox Flexbox__box-align-center">
    <div class="Flexbox Flexbox__box-align-center" style="color:white;font-size:1.42rem;">
      <div *ngIf="flattenHeaders" class="header-test-info" [class.additional]="headerInfo.length > 1">
        <span *ngFor="let headerInfoData of headerInfo">
          <span *ngIf="headerInfoData.cssClassAvailable">
            <span class="{{headerInfoData.cssClass}}" translate>{{headerInfoData.name}}</span>
            <span *ngFor="let headerInfoValue of headerInfoData?.values; trackBy: trackByIndex" class="{{headerInfoData.cssClass}}">{{headerInfoValue | stringTranslate}}</span>
          </span>
          <span *ngIf="headerInfoData.cssClassAvailable === false">
            <span class="additional-test-data-caption" translate>{{headerInfoData.name}}</span>
            <span *ngFor="let headerInfoValue of headerInfoData?.values; trackBy: trackByIndex" class="additional-test-data-value">{{headerInfoValue | stringTranslate}} </span>
          </span>
        </span>
      </div>

      <div *ngIf="flattenHeaders === false"
           class="header-test-info"
           [class.additional]="headerInfo.length > 1"
           (mouseleave)="showInfo = false"
           (mouseenter)="showInfo = true">
        <span>
          <span (click)="showInfo = !showInfo;" class="additional-test-data-caption {{headerInfo[0].cssClass}}" translate>{{headerInfo[0].name}}</span>
          <span *ngFor="let headerInfoValue of headerInfo[0]?.values; trackBy: trackByIndex"
                (click)="showInfo = !showInfo;"
                class="additional-test-data-value {{headerInfo[0].cssClass}}">{{headerInfoValue | stringTranslate}}</span>
          <span *ngIf="headerInfo[0].addRevision" class="fs8" style="padding-left: 0.42rem;padding-top: 0.57rem;">{{getUserDisplayName()}}</span>
        </span>
        <ul *ngIf="headerInfo.length>1"
            [ngClass]="{'hidden':!showInfo}"
            class="additional-test-data">
          <li *ngFor="let headerInfoData of headerInfo.slice(1)">
            <span class="additional-test-data-caption">{{headerInfoData.name | stringTranslate}}</span>
            <span *ngFor="let headerInfoValue of headerInfoData?.values; trackBy: trackByIndex" class="additional-test-data-value">{{headerInfoValue | stringTranslate}}</span>
            <span *ngIf="headerInfoData.addRevision" class="fs8" style="padding-left: 0.42rem;padding-top: 0.57rem;">{{getUserDisplayName()}}</span>
          </li>
        </ul>
      </div>

      <div *ngIf="testActionsPresent === false" class="Flexbox" style="padding-left:2.81rem;">
        <button *ngIf="isPatientEditable"
                (click)="patientDetails()"
                class="img-btn notes-btn top-template-header-content-item fs5 scale"
                style="color:white"
                genTooltip
                [tooltipPosition]="toolTipPositions.BOTTOM"
                tooltipText="Patient Information"
                tooltipShow="true">
          <i class="icon__patient" style="font-size:1.5rem;"></i>
        </button>
        <button [disabled]="!revisionId"
                (click)="toggleNotes();collapseAttachments();"
                class="img-btn notes-btn top-template-header-content-item fs5 scale"
                style="color:white"
                genTooltip
                [tooltipPosition]="toolTipPositions.BOTTOM"
                tooltipText="Notes"
                tooltipShow="true">
          <i class="icon__notifications" style="font-size: 1.57rem;">
            <span class="new-notes-notification" *ngIf="newNotes > 0">{{newNotes}}</span>
          </i>
        </button>
        <button [disabled]="(!revisionId || !isAttachmentEnabled) ? true : null"
                (click)="toggleAttachments();collapseNotes();"
                class="img-btn notes-btn top-template-header-content-item fs5 scale"
                style="color:white"
                genTooltip
                [tooltipPosition]="toolTipPositions.BOTTOM"
                tooltipText="REPORTS_AND_DOCUMENTS"
                tooltipShow="true">
          <i class="icon__attachment" style="font-size: 1.57rem;"></i>
        </button>
        <gen-revise
                *ngIf="(isPerformer || isAdmin) && !isArchived && !backActionButtonPermitted"
                class="img-btn notes-btn fs6 scale"
                [workflow]="currentWorkflow"
                [revisionId]="revisionId"
                [testType]="testConfiguration?.id"
                [tooltipHtml]="isCustomConfig ? 'Revise item' : 'Advance/Revise item'"
                [tooltipPosition]="toolTipPositions.BOTTOM"
                [templatesConfiguration]="reviseTemplates"
                (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                [ngClass]="{'disableAction' : setIsDisabledRevise$ | async}"></gen-revise>
        <gen-back
                *ngIf="(testInDraftMode && isPerformer && !hideBackActionButton && !isArchived) || (backActionButtonPermitted && !hideBackActionButton && (!testIsCompleted || testInDraftMode))"
                class="img-btn btn-back fs6 scale"
                [workflow]="currentWorkflow"
                [revisionId]="revisionId"
                [testType]="testConfiguration.id"
                [tooltipHtml]="'Back to pathway selection'"
                [tooltipPosition]="toolTipPositions.BOTTOM"
                [templatesConfiguration]="reviseTemplates"
                (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                [disabled]="(testIsCompleted && !testInDraftMode) || isBackDisabled"></gen-back>
        <button (click)="removeFromWorklist()"
                *ngIf="editModeIsSupported() && latestRevisionId === currentRevision?.id && testInWorklist && !hideRemoveFromWorklist()"
                genPermissionSchemaRestrict [permissionSchemaKey]="'workflowAnalysisRemove'"
                class="img-btn notes-btn top-template-header-content-item fs5 scale"
                style="color: white;"
                genTooltip
                [tooltipPosition]="toolTipPositions.BOTTOM"
                tooltipText="Remove from worklist"
                tooltipShow="true">
          <span class="icon__cross" style="font-size:1.5rem;"></span>
        </button>
        <button type="button"
                *ngIf="reassignIsEnabled()"
                (click)="reassign()"
                class="img-btn notes-btn top-template-header-content-item fs5 scale"
                style="color: white;"
                genTooltip
                [tooltipPosition]="toolTipPositions.BOTTOM"
                [tooltipText]="'Reassign Item'"
                tooltipShow="true">
          <span class="icon__reassign" style="font-size:1.5rem;"></span>
        </button>
        <ispm-edit-managing-facility
                *ngIf="canChangeManagingFacility()"
                [currentTest]="currentTest"
                [testConfiguration]="testConfiguration"
                [readOnlyParameters]="readOnlyParameters"
                [tooltipText]="changeManagingFacilityActionItem?.label"
                [manageFacilityAction]="changeManagingFacilityActionItem"
                [tooltipPosition]="toolTipPositions.BOTTOM"
                [customCssClass]="'img-btn notes-btn fs5 scale'"
                [customStyleItem] ="{'font-size': '1.5rem'}"></ispm-edit-managing-facility>
        <gen-stop-workflow
                *ngIf="stopActionItem?.enable && isPerformer"
                [currentWorkflow]="currentWorkflow"
                [tooltipText]="stopActionItem?.label"
                [tooltipPosition]="toolTipPositions.BOTTOM"
                [stopAction]="stopActionItem"
                [activeJobItem]="activeJobItem"
                [cssClass]="'img-btn notes-btn fs5 scale'"
                [styleItem]="{'font-size': '1.5rem'}"
                [isDisabled]="setIsDisabledRevise$ | async"></gen-stop-workflow>
        <ispm-manage-tags
                          [configuration]="manageTagsActionItem"
                          [diagnosticOrder]="currentTest"></ispm-manage-tags>
      </div>

      <span *ngFor="let testAction of testActions" [ngSwitch]="testAction.action" class="Flexbox" style="padding-left:0.1rem;">
        <span>
          <button *ngSwitchCase="'notes'"
                  [disabled]="!revisionId || !testAction.enable"
                  (click)="toggleNotes();collapseAttachments();"
                  class="img-btn notes-btn top-template-header-content-item fs5 scale"
                  style="color:white"
                  genTooltip
                  [tooltipPosition]="toolTipPositions.BOTTOM"
                  [tooltipText]="testAction.labelAvailable === false ? 'Notes' : testAction.label" tooltipShow="true">
            <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size: 1.57rem;">
              <span class="new-notes-notification" *ngIf="newNotes > 0">{{newNotes}}</span>
            </i>
            <i *ngIf="testAction.actionIconAvailable === false" class="icon__notifications" style="font-size: 1.57rem;">
              <span class="new-notes-notification" *ngIf="newNotes > 0">{{newNotes}}</span>
            </i>
          </button>
        </span>

        <span>
          <button *ngSwitchCase="'attachments'"
                  [disabled]="!revisionId || !testAction.enable"
                  (click)="toggleAttachments();collapseNotes();"
                  class="img-btn notes-btn top-template-header-content-item fs5 scale"
                  style="color:white"
                  genTooltip
                  [tooltipPosition]="toolTipPositions.BOTTOM"
                  [tooltipText]="testAction.labelAvailable === false ? 'Reports & documents' : testAction.label"
                  tooltipShow="true">
            <i *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size: 1.57rem;"></i>
            <i *ngIf="testAction.actionIconAvailable === false" class="icon__attachment" style="font-size: 1.57rem;"></i>
          </button>
        </span>

        <span *ngIf="testAction.enable">
          <div *ngSwitchCase="'revise'">
            <gen-revise *ngIf="(isPerformer || isAdmin) && !isArchived && !backActionButtonPermitted"
                        class="img-btn notes-btn fs6 scale"
                        [workflow]="currentTest.workflowRequest"
                        [revisionId]="revisionId"
                        [testType]="testConfiguration.id"
                        [tooltipHtml]="testAction.labelAvailable === false ? (isCustomConfig ? 'Revise item' : 'Advance/Revise item') : testAction.label"
                        [tooltipPosition]="toolTipPositions.BOTTOM"
                        [templatesConfiguration]="reviseTemplates"
                        (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                        [ngClass]="{'disableAction' : setIsDisabledRevise$ | async}"></gen-revise>
          </div>
        </span>

        <span *ngIf="testAction.enable">
          <div *ngSwitchCase="'back'">
            <gen-back *ngIf="(testInDraftMode && isPerformer && !hideBackActionButton && !isArchived) || (backActionButtonPermitted && !hideBackActionButton && (!testIsCompleted || testInDraftMode))"
                      class="img-btn btn-back fs6 scale"
                      [workflow]="currentWorkflow"
                      [revisionId]="revisionId"
                      [testType]="testConfiguration.id"
                      [tooltipHtml]="'Back to pathway selection'"
                      [tooltipPosition]="toolTipPositions.BOTTOM"
                      [templatesConfiguration]="reviseTemplates"
                      (reviseCompleted)="goToRevision($event.id,$event.activeRevision)"
                      [disabled]="(testIsCompleted && !testInDraftMode) || isBackDisabled"></gen-back>
          </div>
        </span>

        <div *ngSwitchCase="'removeFromWorkList'">
          <span>
            <button (click)="removeFromWorklist()"
                    [disabled]="!testAction.enable"
                    *ngIf="editModeIsSupported() && latestRevisionId === currentRevision?.id && testInWorklist && !hideRemoveFromWorklist()"
                    genPermissionSchemaRestrict
                    [permissionSchemaKey]="'workflowAnalysisRemove'"
                    class="img-btn notes-btn top-template-header-content-item fs5 scale"
                    style="color: white;"
                    genTooltip
                    [tooltipPosition]="toolTipPositions.BOTTOM"
                    [tooltipText]="testAction.labelAvailable === false ? 'Remove from worklist' : testAction.label" tooltipShow="true">
              <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
              <span *ngIf="testAction.actionIconAvailable === false" class="icon__cross" style="font-size:1.5rem;"></span>
            </button>
          </span>
        </div>

        <span>
          <ispm-manage-tags *ngSwitchCase="'manageTags'"
                            [configuration]="manageTagsActionItem"
                            [diagnosticOrder]="currentTest"></ispm-manage-tags>
        </span>

        <ng-container *ngIf="reassignIsEnabled()">
          <span>
            <button *ngSwitchCase="'reassign'" type="button"
                    (click)="reassign()"
                    class="img-btn notes-btn top-template-header-content-item fs5 scale"
                    [disabled]="!testAction.enable"
                    style="color: white;"
                    genTooltip
                    [tooltipPosition]="toolTipPositions.BOTTOM"
                    [tooltipText]="testAction.labelAvailable === false ? 'Reassign Item' : testAction.label" tooltipShow="true">
              <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
              <span *ngIf="testAction.actionIconAvailable === false" class="icon__reassign"
                            style="font-size:1.5rem;"></span>
            </button>
          </span>

          <span>
             <button *ngSwitchCase="'patientDetails'" type="button"
                     (click)="patientDetails()"
                     class="img-btn notes-btn top-template-header-content-item fs5 scale"
                     [disabled]="!testAction.enable"
                     style="color: white;"
                     genTooltip [tooltipPosition]="toolTipPositions.BOTTOM" [tooltipText]="testAction.labelAvailable === false ? 'Patient Details' : testAction.label">
                    <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
                    <span *ngIf="testAction.actionIconAvailable === false" class="icon__patient"
                          style="font-size:1.5rem;"></span>
              </button>
          </span>

          <span *ngIf="testAction.enable">
            <ng-container *ngSwitchCase="'change_facility'">
              <ispm-edit-managing-facility
                       *ngIf="canChangeManagingFacility()"
                       [testConfiguration]="testConfiguration"
                       [currentTest]="currentTest"
                       [readOnlyParameters]="readOnlyParameters"
                       [tooltipText]="testAction?.label"
                       [manageFacilityAction]="changeManagingFacilityActionItem"
                       [tooltipPosition]="toolTipPositions.BOTTOM"
                       [customCssClass]  ="'img-btn notes-btn fs5 scale'"
                       [customStyleItem]="{'font-size': '1.5rem'}"></ispm-edit-managing-facility>
            </ng-container>
          </span>

          <span *ngIf="testAction.enable">
            <div *ngSwitchCase="'stop'">
              <gen-stop-workflow
                      *ngIf="isPerformer"
                      [currentWorkflow]="currentWorkflow"
                      [tooltipText]="testAction.label"
                      [tooltipPosition]="toolTipPositions.BOTTOM"
                      [stopAction]="stopActionItem"
                      [activeJobItem]="activeJobItem"
                      [cssClass]="'img-btn notes-btn fs5 scale'"
                      [styleItem]="{'font-size': '1.5rem'}"
                      [isDisabled]="setIsDisabledRevise$ | async"></gen-stop-workflow>
            </div>
          </span>

          <span *ngIf="testAction.enable">
            <button *ngSwitchCase="'export'" type="button"
                    (click)="export(testAction)"
                    class="img-btn notes-btn top-template-header-content-item fs5 scale"
                    [disabled]="!testAction.enable"
                    style="color: white;"
                    genTooltip
                    [tooltipPosition]="toolTipPositions.BOTTOM"
                    [tooltipText]="testAction.label" tooltipShow="true">
              <span *ngIf="testAction.actionIconAvailable" class="{{testAction.icon}}" style="font-size:1.5rem;"></span>
              <span *ngIf="testAction.actionIconAvailable === false" class="pancancer__icon__icon-dls-export" style="font-size:1.5rem;"></span>
            </button>
          </span>

          <ng-container *ngIf="!!testAction?.actionList?.length">
            <drop-down-menu class="img-btn notes-btn fs6 scale"
                            [menuClassName]="testAction.icon"
                            [tooltipHtml]="testAction.label"
                            [menuItems]="testAction.actionList"
                            [disabled]="!testAction.enable"
                            [permissionId]="testAction.permissionId"></drop-down-menu>
          </ng-container>
        </ng-container>
      </span>
    </div>
  </section>

  <!-- Slap in workflow bar here -->
  <ng-content *ngIf="showOldWorkflowBar"></ng-content>
  <gen-workflow-bar class="test-bar-workflow-bar"
                    *ngIf="!showOldWorkflowBar && !isCustomConfig"
                    [stepTaglineField]="stepTagLine"></gen-workflow-bar>
  <gen-custom-workflow-bar class="test-bar-workflow-bar"
                           *ngIf="!showOldWorkflowBar && isCustomConfig && customRevisionData"
                           [currentRevision]="customRevisionData"
                           [patientAnalyses]="patientAnalyses"
                           [stepTaglineField]="stepTagLine"></gen-custom-workflow-bar>
  <gen-step-confirmation-button class="test-bar-btn"
                                [currentRevision]="currentRevision"
                                [currentWorkflow]="currentWorkflow"></gen-step-confirmation-button>
</section>
